/* eslint-disable react/require-default-props */
import React from 'react';
import { ContractsAnalysisItemTypes } from 'store/modules/contract_analysis/types';
import moment from 'moment';
import StatusFilterBadge from 'components/atoms/status_filter_badge';
import { Link } from 'react-router-dom';

interface ContractAnalysisItemProps {
  contract: ContractsAnalysisItemTypes;
  onView?: (id: string) => void;
}

const ContractAnalysisItem = ({ contract, onView }: ContractAnalysisItemProps) => {
  return (
    <div className="list-group-item d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center">
        <div className="mr-3">
          <i className="material-icons text-success">description</i>
        </div>

        <div>
          <div className="font-weight-bold">{contract?.bidding_number}</div>
          <div className="text-muted">
            {contract?.organization} • Data: {moment(contract?.created_at).format('DD/MM/YYYY')}
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center">
        <StatusFilterBadge status={contract?.status} />
        {contract?.status === 'completed' && onView && (
          <button
            type="button"
            className="btn btn-link p-0 text-primary d-flex align-items-center font-weight-bold"
            onClick={() => onView(String(contract.id))}
          >
            Visualizar Análise
            <i className="material-icons ml-1">chevron_right</i>
          </button>
        )}
        {contract?.status === 'completed' && !onView && (
          <Link
            to={`/validar_contrato/relatorio/${contract?.id}`}
            className="text-primary d-flex align-items-center font-weight-bold"
          >
            Visualizar Análise
            <i className="material-icons ml-1">chevron_right</i>
          </Link>
        )}
      </div>
    </div>
  );
};

export default ContractAnalysisItem;
